import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { User } from "app/users";

@Component({
  selector: "app-advisor-contact-step",
  templateUrl: "./advisor-contact-step.component.html",
  styleUrls: ["./advisor-contact-step.component.scss"],
  standalone: false
})
export class AdvisorContactStepComponent implements OnInit {
  email = "";
  @Input() user: User;
  @Input() isEmailSending = false;
  @Output() submitInquiry = new EventEmitter<string>();

  ngOnInit(): void {
    if (this.user) this.email = this.user.email;
  }

  onSubmit(): void {
    this.submitInquiry.emit(this.email);
  }
}
